export default __webpack_public_path__ + "static/media/red-left.5034aa12.svg";